import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=15014da4&"
import script from "./SetPassword.vue?vue&type=script&lang=js&"
export * from "./SetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports